import React from 'react';
import PropTypes, { InferProps } from 'prop-types';

const propTypes = {
  title: PropTypes.string,
  summary: PropTypes.string,
  expired: PropTypes.string,
  link: PropTypes.string,
  taxonomies: PropTypes.array,
};

export default function Exemption(props: InferProps<typeof propTypes>): JSX.Element {
  const {
    title,
    expired,
    link,
    taxonomies,
  } = props;

  const tags = [expired, ...taxonomies];

  return (
    <a href={link} rel='noreferrer noopener' target='_blank' className="exemption">
        <div className="exemption__name">
        {title}
        </div>
      <div className="exemption__tags">
      {tags.join(' | ')}
      </div>
    </a>
  );
}
